const AssessmentResume = () => (
  <svg
    focusable={false}
    xmlns='http://www.w3.org/2000/svg'
    width='62'
    height='62'
    viewBox='0 0 62 62'
  >
    <g fill='none' fillRule='evenodd' stroke='#A99BCA' strokeWidth='1.875'>
      <path
        fill='#F2F1FF'
        fillRule='nonzero'
        d='M1 31c0 16.542 13.458 30 30 30s30-13.458 30-30S47.542 1 31 1 1 14.458 1 31z'
      />
      <g strokeLinecap='round' strokeLinejoin='round'>
        <path
          fill='#FFF'
          fillRule='nonzero'
          d='M42.25 43.963c0 .711-.572 1.287-1.275 1.287h-19.2a1.28 1.28 0 0 1-1.275-1.287V20.288A1.282 1.282 0 0 1 21.775 19h19.2c.703 0 1.275.577 1.275 1.288v23.675z'
        />
        <path d='M24.25 25.821l.968 1.429 2.782-3m3.75 1.5h6.75m-14.25 6.071l.968 1.429 2.782-3m3.75 2.25h6.75m-14.25 6.071L25.218 40 28 37m3.75 2.25h6.75' />
      </g>
    </g>
  </svg>
);

export default AssessmentResume;
